import { Component,	Input } from '@angular/core';

import { VBrick360UtilService } from '../threeSixty/VBrick360Util.Service';

import { VbPlaybackManagerComponent } from './VbPlaybackManager.Component';

@Component({
	selector: 'vb-no-supported-playbacks',
	host: {
		'[class.smallSizePlayer]': 'isSmallSizePlayer'
	},
	template: `
		<span class="warningSign glyphicons white circle_exclamation_mark"></span>
		<span [hidden]="is360PlaybackNotSupported">{{ translations.playbackNotSupported }}</span>
		<span [hidden]="!is360PlaybackNotSupported">{{ translations.playback360NotSupported }}</span>`,
	standalone: false,
	styleUrls: ['./VbNoSupportedPlaybacks.Component.ng.less']
})
export class VbNoSupportedPlaybacksComponent {
	@Input() public translations: Record<string, string>;
	@Input() public playbackManager: VbPlaybackManagerComponent;
	@Input() public isSmallSizePlayer: boolean;

	constructor(
		private VBrick360Util: VBrick360UtilService
	) {}

	public get is360PlaybackNotSupported(): boolean {
		if (!this.playbackManager || !this.playbackManager.playbackOptions) {
			return false;
		}

		const { playbackOptions } = this.playbackManager;

		return playbackOptions.length &&
			playbackOptions.every(option => option.is360Enabled) &&
			this.VBrick360Util.isUnsupportedBrowser();
	}
}
